import { api_get, api_put, PROYECT } from "../../../services/api";
import { inventoryDigitalMovementsTypes } from "../../reducers/inventoryDigitalMovements/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { newDate } from "../../../helpers/dateTools";

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`;

const {
  HANDLE_DIGITAL_MOV_INPUTS,
  GET_INVENTORIES_DIGITAL_MOV,
  DIGITAL_UPDATE_ACTION,
} = inventoryDigitalMovementsTypes;

export const handleInventoryDigitalMovementsInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_DIGITAL_MOV_INPUTS, payload: { key, value } });
};

export const getInventoryDigitalMovementsAction = (idStation = "", date = newDate()) => async dispatch => {
  const url = `${mainUrl}/station-inventory/edit-digital-percentage-requests/${idStation}?date=${date}`;
  dispatch(startRequestComp('loadingInventoryDigitalMovements'));
  try {
    const data = await api_get(url);
    dispatch({ type: GET_INVENTORIES_DIGITAL_MOV, payload: data });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingInventoryDigitalMovements'));
};

export const inventoryDigitalApprove = (idRequest = "", form, action = null) => async dispatch => {
  const url = `${mainUrl}/station-inventory/resolve-request-edit-digital-percentage/${idRequest}`;
  dispatch(startRequestComp('loadingInventoryDigitalMovementsActions'));
  try {
    await api_put(url, form);
    dispatch({ type: DIGITAL_UPDATE_ACTION, payload: { id: idRequest, status: form.action } });
    action && action();
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingInventoryDigitalMovementsActions'));
};
